import { render, staticRenderFns } from "./salesRecords.vue?vue&type=template&id=265444bc&scoped=true"
import script from "./salesRecords.vue?vue&type=script&lang=js"
export * from "./salesRecords.vue?vue&type=script&lang=js"
import style0 from "./salesRecords.vue?vue&type=style&index=0&id=265444bc&prod&lang=scss"
import style1 from "./salesRecords.vue?vue&type=style&index=1&id=265444bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265444bc",
  null
  
)

export default component.exports